/* SS - the buy box on the PDP, 17.09.2026 (see assets/ss-buybox.css).
   1) campaign pill: native <details>/<summary> (snippets/ss-deal-pill.liquid) - no JS, so no lag while scripts load
   2) rating: puts «4,9 ·» in front of the Judge.me preview badge text («117 anmeldelser»). The number comes from
      product.metafields.reviews.rating (data-ss-rating on the wrapper, set in snippets/kalis-product-template.liquid).
      Judge.me's script may re-render the badge, so a MutationObserver puts the number back. */
(function () {
  'use strict';
  /* 1) the campaign pill is a native <details> since 17.09 (opened with no JS) - nothing to do here */
  function fmt(n) { return (Math.round(n * 10) / 10).toFixed(1).replace('.', ','); }
  function rating(wrap) {
    var r = parseFloat(wrap.getAttribute('data-ss-rating'));
    if (!(r > 0)) {
      var raw = wrap.getAttribute('data-ss-rating-raw') || '';
      try { var j = JSON.parse(raw); r = parseFloat(j.value || j.rating); } catch (err) { var m = raw.match(/(\d+(?:[.,]\d+)?)/); if (m) r = parseFloat(m[1].replace(',', '.')); }
    }
    return r > 0 ? r : null;
  }
  function inject(wrap) {
    var t = wrap.querySelector('.jdgm-prev-badge__text');
    if (!t || t.querySelector('.ss-rating__avg')) return;
    var r = rating(wrap); if (!r) return;
    var s = document.createElement('span'); s.className = 'ss-rating__avg'; s.textContent = fmt(r) + ' · ';
    t.insertBefore(s, t.firstChild);
  }
  function init() {
    document.querySelectorAll('.ss-rating').forEach(function (wrap) {
      inject(wrap);
      new MutationObserver(function () { inject(wrap); }).observe(wrap, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
